import React from "react";
import { useStore } from "effector-react";
import { Box, IconButton, Tooltip, Typography } from "@material-ui/core";
import { FastForward, FastRewind, Pause, PlayArrow, Shuffle } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { pause, resume } from "frontend/src/features/control-audio";
import { $activeWebSchedule, stopWebScheduleAttempted, } from "frontend/src/features/play-web-schedule";
import { state } from "frontend/src/shared/state";
import { tryPlayNextTrackInQueue, tryPlayPreviousTrackInQueue, } from "frontend/src/features/play-track-from-queue";
import { $isAudioPlaying } from "frontend/src/domain/audio";
import { $playerHasCurrentTrack, $playerHasNextTrack, $playerHasPreviousTrack, $playerNextTrack, $playerPreviousTrack, $playerShuffleEnabled, playerShuffleToggled, } from "frontend/src/domain/player-track-queue";
var useStyles = makeStyles({
    icon: { height: 40, width: 40 },
    playButton: { opacity: 1, color: "inherit" },
    shuffleButton: { opacity: 0.35 },
    shuffleButtonActive: { opacity: 1, color: "inherit" },
});
export var Controls = function () {
    var classes = useStyles();
    var isPlaying = useStore($isAudioPlaying);
    var activeWebSchedule = useStore($activeWebSchedule);
    var hasCurrentTrack = useStore($playerHasCurrentTrack);
    var hasNextTrack = useStore($playerHasNextTrack);
    var hasPreviousTrack = useStore($playerHasPreviousTrack);
    var nextTrack = useStore($playerNextTrack);
    var previousTrack = useStore($playerPreviousTrack);
    var shuffleEnabled = useStore($playerShuffleEnabled);
    var Icon = isPlaying ? Pause : PlayArrow;
    var onAudioControlButtonClick = function () {
        if (isPlaying && activeWebSchedule) {
            stopWebScheduleAttempted();
            return;
        }
        isPlaying ? pause() : resume();
    };
    var btnNextOnClick = function () {
        state.trackSwitchedByUser = true;
        setTimeout(function () { state.trackSwitchedByUser = false; }, 1000);
        tryPlayNextTrackInQueue();
    };
    var btnPrevOnClick = function () {
        state.trackSwitchedByUser = true;
        setTimeout(function () { state.trackSwitchedByUser = false; }, 1000);
        tryPlayPreviousTrackInQueue();
    };
    return (React.createElement(Box, null,
        React.createElement(Tooltip, { title: hasPreviousTrack ? (React.createElement(React.Fragment, null,
                React.createElement(Typography, { display: "block", variant: "caption" }, previousTrack === null || previousTrack === void 0 ? void 0 : previousTrack.title),
                React.createElement(Typography, { variant: "caption" }, previousTrack &&
                    previousTrack.type === "public" &&
                    previousTrack.artist))) : ("") },
            React.createElement("span", null,
                React.createElement(IconButton, { size: "small", disabled: !hasPreviousTrack, onClick: btnPrevOnClick },
                    React.createElement(FastRewind, null)))),
        React.createElement(IconButton, { size: "small", disabled: !hasCurrentTrack, onClick: onAudioControlButtonClick },
            React.createElement(Icon, { className: classes.icon })),
        React.createElement(IconButton, { size: "small", disabled: !hasCurrentTrack, onClick: function () { return playerShuffleToggled(); }, className: shuffleEnabled ? classes.shuffleButtonActive : classes.shuffleButton },
            React.createElement(Shuffle, null)),
        React.createElement(Tooltip, { title: hasNextTrack ? (React.createElement(React.Fragment, null,
                React.createElement(Typography, { display: "block", variant: "caption" }, nextTrack === null || nextTrack === void 0 ? void 0 : nextTrack.title),
                React.createElement(Typography, { variant: "caption" }, nextTrack && nextTrack.type === "public" && nextTrack.artist))) : ("") },
            React.createElement("span", null,
                React.createElement(IconButton, { size: "small", disabled: !hasNextTrack, onClick: btnNextOnClick },
                    React.createElement(FastForward, null))))));
};
